export const REQUEST_SAVE_ADDON = 'REQUEST_SAVE_ADDON';
export const RECEIVE_SAVE_ADDON = 'RECEIVE_SAVE_ADDON';
export const SET_SAVE_ADDON_FAILURE = 'SET_SAVE_ADDON_FAILURE';

export const REQUEST_SAVE_ENTERTAINMENT = 'REQUEST_SAVE_ENTERTAINMENT';
export const RECEIVE_SAVE_ENTERTAINMENT = 'RECEIVE_SAVE_ENTERTAINMENT';
export const SET_SAVE_ENTERTAINMENT_FAILURE = 'SET_SAVE_ENTERTAINMENT_FAILURE';

export const REQUEST_DELETE_ENTERTAINMENT = 'REQUEST_DELETE_ENTERTAINMENT';
export const RECEIVE_DELETE_ENTERTAINMENT = 'RECEIVE_DELETE_ENTERTAINMENT';
export const SET_DELETE_ENTERTAINMENT_FAILURE = 'SET_DELETE_ENTERTAINMENT_FAILURE';

export const CLEAR_SAVE_ADDON_ERROR_MESSAGE = 'CLEAR_SAVE_ADDON_ERROR_MESSAGE';
